"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDietaryInfo = void 0;
const React = require("react");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductDietaryInfo");
/**
 * Shows dietary information about a product or ingredient.
 *
 * Examples include:
 *
 *  - Gluten Free
 *  - Vegetarian
 *  - Vegan
 */
const ProductDietaryInfo = ({ product }) => {
    const { productId, category: { showDietaryInfo }, dietaryInfo } = product;
    if (!showDietaryInfo) {
        return null;
    }
    return (React.createElement("div", { className: css("") }, showDietaryInfo && (React.createElement("div", { className: css("dietary_info") }, dietaryInfo &&
        dietaryInfo.map((info) => (React.createElement("div", { key: `${productId}-${info.label}`, className: css("dietary_label"), style: { backgroundColor: info.colour || styles.colorPrimary } }, info.label)))))));
};
exports.ProductDietaryInfo = ProductDietaryInfo;
//# sourceMappingURL=index.js.map